export type FontType = "base" | "heading"

export const fontFamily = (type: FontType) => {
  switch (type) {
    case "base":
      return '"Open Sans", sans-serif'
    case "heading":
      return '"Open Sans", sans-serif'
    default:
      return '"Open Sans", sans-serif'
  }
}
